import ActBacteriologicalTestForm from "./ActBacteriologicalTestForm";
import ActBacteriologicalPDFGenerator from "./ActBacteriologicalPDFGenerator";
import withActDetailCopy from "../withActDetailCopy";

const actFormKazakhName = 'Бактериологиялық тест алу АКТIСI'
const actFormName = 'АКТ отбора бактериологических тестов'
const actFormNumber = '001'
const actName = 'ActBacteriologicalTest'

export default withActDetailCopy(ActBacteriologicalTestForm, ActBacteriologicalPDFGenerator, actFormKazakhName, actFormName, actFormNumber, actName)